module.exports = __webpack_public_path__ + "static/media/graph-2.6d622892.svg";